/*
 * Ficha de artista (`snippets/main-artist.liquid`): barra de secciones fija bajo la cabecera
 * del sitio, pestaña activa según la sección visible y «Leer más» de la biografía.
 *
 * Sin este script la barra se queda en su sitio (no se fija con el nombre) y la biografía se
 * ve entera. Ver EXBS-2.
 */
(function () {
  'use strict';

  // Cabecera fija del sitio (`sections/header.liquid`): la barra se fija justo debajo.
  var CABECERA = '#site-control';

  function altoCabecera() {
    var cabecera = document.querySelector(CABECERA);
    return cabecera ? cabecera.getBoundingClientRect().height : 0;
  }

  function iniciaBarra(raiz) {
    var barra = raiz.querySelector('[data-artist-nav]');
    var centinela = raiz.querySelector('[data-artist-nav-sentinel]');
    var pestanas = Array.prototype.slice.call(raiz.querySelectorAll('[data-artist-tab]'));
    var secciones = Array.prototype.slice.call(raiz.querySelectorAll('[data-artist-section]'));
    if (!barra || !centinela) {
      return;
    }

    var observadorFijo = null;
    var observadorSecciones = null;

    function activa(id) {
      pestanas.forEach(function (pestana) {
        var esta = pestana.getAttribute('href') === '#' + id;
        pestana.classList.toggle('is-active', esta);
        if (esta) {
          pestana.setAttribute('aria-current', 'true');
        } else {
          pestana.removeAttribute('aria-current');
        }
      });
    }

    function observa() {
      var alto = altoCabecera();
      raiz.style.setProperty('--exh-artist-header', alto + 'px');

      if (observadorFijo) {
        observadorFijo.disconnect();
      }
      observadorFijo = new IntersectionObserver(function (entradas) {
        barra.classList.toggle('is-stuck', !entradas[0].isIntersecting && entradas[0].boundingClientRect.top < alto);
      }, { rootMargin: '-' + alto + 'px 0px 0px 0px' });
      observadorFijo.observe(centinela);

      if (observadorSecciones) {
        observadorSecciones.disconnect();
      }
      // Activa la sección que cruza una franja estrecha justo bajo la barra.
      var limite = alto + barra.getBoundingClientRect().height + 1;
      observadorSecciones = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (entrada) {
          if (entrada.isIntersecting) {
            activa(entrada.target.id);
          }
        });
      }, { rootMargin: '-' + limite + 'px 0px -' + (window.innerHeight - limite - 2) + 'px 0px' });
      secciones.forEach(function (seccion) {
        observadorSecciones.observe(seccion);
      });
    }

    if (secciones[0]) {
      activa(secciones[0].id);
    }
    observa();
    window.addEventListener('resize', observa);
  }

  function iniciaBiografia(raiz) {
    var texto = raiz.querySelector('[data-artist-bio]');
    var boton = raiz.querySelector('[data-artist-read-more]');
    if (!texto || !boton) {
      return;
    }

    texto.classList.add('is-collapsed');
    if (texto.scrollHeight <= texto.clientHeight + 1) {
      texto.classList.remove('is-collapsed');
      return;
    }

    boton.hidden = false;
    boton.addEventListener('click', function () {
      var abierta = texto.classList.toggle('is-collapsed') === false;
      boton.setAttribute('aria-expanded', String(abierta));
      boton.textContent = abierta ? boton.dataset.labelLess : boton.dataset.labelMore;
    });
  }

  function inicia() {
    document.querySelectorAll('[data-artist-page]').forEach(function (raiz) {
      iniciaBarra(raiz);
      iniciaBiografia(raiz);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inicia);
  } else {
    inicia();
  }
})();
